// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_bytes from "melange.js/caml_bytes.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_float from "melange.js/caml_float.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Field from "./field.js";
import * as Ocaml_protoc_plugin__Infix from "./infix.js";
import * as Ocaml_protoc_plugin__Reader from "./reader.js";
import * as Ocaml_protoc_plugin__Result from "./result.js";
import * as Ocaml_protoc_plugin__Spec from "./spec.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Map from "melange/map.js";
import * as Stdlib__StringLabels from "melange/stringLabels.js";
import * as Stdlib__Sys from "melange/sys.js";
import * as OcamlStringConvert from "ocaml-string-convert";

const Restart_full = /* @__PURE__ */ Caml_exceptions.create("Ocaml_protoc_plugin__Deserialize.Restart_full");

function error_wrong_field(str, field) {
  return Ocaml_protoc_plugin__Result.raise({
    NAME: "Wrong_field_type",
    VAL: [
      str,
      Curry._1(Ocaml_protoc_plugin__Field.show, field)
    ]
  });
}

function decode_zigzag_unboxed(v) {
  if ((v & 1) === 0) {
    return v / 2 | 0;
  } else {
    return Math.imul(v / 2 | 0, -1) - 1 | 0;
  }
}

let int_of_uint32;

if (Stdlib__Sys.word_size !== 32) {
  if (Stdlib__Sys.word_size !== 64) {
    throw new Caml_js_exceptions.MelangeError("Assert_failure", {
          MEL_EXN_ID: "Assert_failure",
          _1: [
            "vendored/ocaml_protoc_plugin/deserialize.ml",
            49,
            4
          ]
        });
  }
  int_of_uint32 = (function (n) {
    return n & -1;
  });
} else {
  int_of_uint32 = (function (prim) {
    return prim;
  });
}

function read_of_spec(Enum) {
  if (/* tag */ typeof Enum === "number" || typeof Enum === "string") {
    switch (Enum) {
      case /* Double */ 0 :
        return [
          /* Fixed64 */ 1,
          (function (param) {
            return Caml_int64.float_of_bits(Ocaml_protoc_plugin__Reader.read_fixed64(param));
          })
        ];
      case /* Float */ 1 :
        return [
          /* Fixed32 */ 2,
          (function (param) {
            return Caml_float.caml_int32_float_of_bits(Ocaml_protoc_plugin__Reader.read_fixed32(param));
          })
        ];
      case /* Int32 */ 2 :
        return [
          /* Varint */ 0,
          Ocaml_protoc_plugin__Reader.read_varint_unboxed
        ];
      case /* UInt32 */ 3 :
        return [
          /* Varint */ 0,
          Ocaml_protoc_plugin__Reader.read_varint_unboxed
        ];
      case /* SInt32 */ 4 :
        return [
          /* Varint */ 0,
          (function (param) {
            return decode_zigzag_unboxed(Ocaml_protoc_plugin__Reader.read_varint_unboxed(param));
          })
        ];
      case /* Fixed32 */ 5 :
      case /* SFixed32 */ 6 :
        return [
          /* Fixed32 */ 2,
          Ocaml_protoc_plugin__Reader.read_fixed32
        ];
      case /* SInt32_int */ 9 :
        return [
          /* Varint */ 0,
          (function (param) {
            return decode_zigzag_unboxed(Ocaml_protoc_plugin__Reader.read_varint_unboxed(param));
          })
        ];
      case /* Fixed32_int */ 10 :
        return [
          /* Fixed32 */ 2,
          (function (param) {
            return Curry._1(int_of_uint32, Ocaml_protoc_plugin__Reader.read_fixed32(param));
          })
        ];
      case /* SFixed32_int */ 11 :
        return [
          /* Fixed32 */ 2,
          Ocaml_protoc_plugin__Reader.read_fixed32
        ];
      case /* UInt64 */ 12 :
      case /* Int64 */ 13 :
        return [
          /* Varint */ 0,
          Ocaml_protoc_plugin__Reader.read_varint
        ];
      case /* SInt64 */ 14 :
        return [
          /* Varint */ 0,
          (function (param) {
            let v = Ocaml_protoc_plugin__Reader.read_varint(param);
            if (Caml.i64_eq(Ocaml_protoc_plugin__Infix.Int64.land(v, Caml_int64.one), Caml_int64.zero)) {
              return Ocaml_protoc_plugin__Infix.Int64.$slash(v, [
                0,
                2
              ]);
            } else {
              return Ocaml_protoc_plugin__Infix.Int64.$neg(Ocaml_protoc_plugin__Infix.Int64.$star(Ocaml_protoc_plugin__Infix.Int64.$slash(v, [
                0,
                2
              ]), Caml_int64.neg_one), Caml_int64.one);
            }
          })
        ];
      case /* Fixed64 */ 15 :
      case /* SFixed64 */ 16 :
        return [
          /* Fixed64 */ 1,
          Ocaml_protoc_plugin__Reader.read_fixed64
        ];
      case /* SInt64_int */ 19 :
        return [
          /* Varint */ 0,
          (function (param) {
            return decode_zigzag_unboxed(Ocaml_protoc_plugin__Reader.read_varint_unboxed(param));
          })
        ];
      case /* Fixed64_int */ 20 :
        return [
          /* Fixed64 */ 1,
          (function (param) {
            return Caml_int64.to_int32(Ocaml_protoc_plugin__Reader.read_fixed64(param));
          })
        ];
      case /* SFixed64_int */ 21 :
        return [
          /* Fixed64 */ 1,
          (function (param) {
            return Caml_int64.to_int32(Ocaml_protoc_plugin__Reader.read_fixed64(param));
          })
        ];
      case /* Bool */ 22 :
        return [
          /* Varint */ 0,
          (function (reader) {
            return Ocaml_protoc_plugin__Reader.read_varint_unboxed(reader) !== 0;
          })
        ];
      case /* String */ 23 :
        return [
          /* Length_delimited */ 3,
          (function (reader) {
            const match = Ocaml_protoc_plugin__Reader.read_length_delimited(reader);
            return OcamlStringConvert.fromFakeUTF8String(Stdlib__StringLabels.sub(match.data, match.offset, match.length));
          })
        ];
      case /* Bytes */ 24 :
        return [
          /* Length_delimited */ 3,
          (function (reader) {
            const match = Ocaml_protoc_plugin__Reader.read_length_delimited(reader);
            const length = match.length;
            const v = Caml_bytes.caml_create_bytes(length);
            Caml_bytes.caml_blit_string(match.data, match.offset, v, 0, length);
            return v;
          })
        ];
      default:
        return [
          /* Varint */ 0,
          Ocaml_protoc_plugin__Reader.read_varint_unboxed
        ];
    }
  } else {
    if (Enum.TAG === /* Enum */ 0) {
      const Enum$1 = Enum._0;
      return [
        /* Varint */ 0,
        (function (param) {
          return Curry._1(Enum$1.from_int_exn, Ocaml_protoc_plugin__Reader.read_varint_unboxed(param));
        })
      ];
    }
    const Message = Enum._0;
    return [
      /* Length_delimited */ 3,
      (function (reader) {
        const match = Ocaml_protoc_plugin__Reader.read_length_delimited(reader);
        return Curry._1(Message.from_proto_exn, Ocaml_protoc_plugin__Reader.create(match.offset, match.length, match.data));
      })
    ];
  }
}

function id(x) {
  return x;
}

function keep_last(param, v) {
  return v;
}

function keep_last_opt(param, v) {
  return Caml_option.some(v);
}

function read_field(param, map, v, reader, field_type) {
  if (param[0] === field_type) {
    return Curry._2(map, v, Curry._1(param[1], reader));
  }
  const field = Ocaml_protoc_plugin__Reader.read_field_content(field_type)(reader);
  return error_wrong_field("Deserialize", field);
}

function read_map_entry(read_key, read_value) {
  const get_value = read_value[2];
  const get_key = read_key[2];
  const match = Stdlib__ListLabels.hd(read_key[0]);
  const read_key_f = match[1];
  const key_index = match[0];
  const match$1 = Stdlib__ListLabels.hd(read_value[0]);
  const read_value_f = match$1[1];
  const value_index = match$1[0];
  const partial_arg_0 = read_key[1];
  const partial_arg_1 = read_value[1];
  const partial_arg = [
    partial_arg_0,
    partial_arg_1
  ];
  return function (param) {
    let _param = partial_arg;
    while (true) {
      const param$1 = _param;
      const value = param$1[1];
      const key = param$1[0];
      if (!Ocaml_protoc_plugin__Reader.has_more(param)) {
        return [
          Curry._1(get_key, key),
          Curry._1(get_value, value)
        ];
      }
      const match = Ocaml_protoc_plugin__Reader.read_field_header(param);
      const field_type = match[0];
      const index = match[1];
      if (index === key_index) {
        const key$1 = Curry._3(read_key_f, key, param, field_type);
        _param = [
          key$1,
          value
        ];
        continue;
      }
      if (index === value_index) {
        const value$1 = Curry._3(read_value_f, value, param, field_type);
        _param = [
          key,
          value$1
        ];
        continue;
      }
      Ocaml_protoc_plugin__Reader.read_field_content(field_type)(param);
      _param = [
        key,
        value
      ];
      continue;
    };
  };
}

function value(param) {
  switch (param.TAG) {
    case /* Basic */ 0 :
      const partial_arg = read_of_spec(param._1);
      const read = function (param, param$1, param$2) {
        return read_field(partial_arg, keep_last, param, param$1, param$2);
      };
      return [
        {
          hd: [
            param._0[0],
            read
          ],
          tl: /* [] */ 0
        },
        param._2,
        id
      ];
    case /* Basic_opt */ 1 :
      const spec = param._1;
      let map;
      if (/* tag */ typeof spec === "number" || typeof spec === "string" || spec.TAG !== /* Message */ 1) {
        map = keep_last_opt;
      } else {
        const Message = spec._0;
        map = (function (param, param$1) {
          let merge = Message.merge;
          if (param !== undefined) {
            return Caml_option.some(Curry._2(merge, Caml_option.valFromOption(param), param$1));
          } else {
            return Caml_option.some(param$1);
          }
        });
      }
      const partial_arg$1 = read_of_spec(spec);
      const read$1 = function (param, param$1, param$2) {
        return read_field(partial_arg$1, map, param, param$1, param$2);
      };
      return [
        {
          hd: [
            param._0[0],
            read$1
          ],
          tl: /* [] */ 0
        },
        undefined,
        id
      ];
    case /* Basic_req */ 2 :
      const spec$1 = param._1;
      const index = param._0[0];
      const partial_arg$2 = read_of_spec(spec$1);
      const read$2 = function (param, param$1, param$2) {
        return read_field(partial_arg$2, keep_last_opt, param, param$1, param$2);
      };
      const getter = function (v) {
        if (v !== undefined) {
          return Caml_option.valFromOption(v);
        } else {
          return Ocaml_protoc_plugin__Result.raise({
            NAME: "Required_field_missing",
            VAL: [
              index,
              Ocaml_protoc_plugin__Spec.show(spec$1)
            ]
          });
        }
      };
      return [
        {
          hd: [
            index,
            read$2
          ],
          tl: /* [] */ 0
        },
        undefined,
        getter
      ];
    case /* Repeated */ 3 :
      const spec$2 = param._1;
      const index$1 = param._0[0];
      if (param._2 === /* Packed */ 0) {
        const match = read_of_spec(spec$2);
        const read_f = match[1];
        const field_type = match[0];
        const read$3 = function (vs, reader, ft) {
          if (ft === /* Length_delimited */ 3) {
            const match = Ocaml_protoc_plugin__Reader.read_length_delimited(reader);
            const reader$1 = Ocaml_protoc_plugin__Reader.create(match.offset, match.length, match.data);
            let _acc = vs;
            while (true) {
              const acc = _acc;
              if (!Ocaml_protoc_plugin__Reader.has_more(reader$1)) {
                return acc;
              }
              _acc = {
                hd: Curry._1(read_f, reader$1),
                tl: acc
              };
              continue;
            };
          }
          if (ft === field_type) {
            return {
              hd: Curry._1(read_f, reader),
              tl: vs
            };
          }
          const field = Ocaml_protoc_plugin__Reader.read_field_content(ft)(reader);
          return error_wrong_field("Deserialize", field);
        };
        return [
          {
            hd: [
              index$1,
              read$3
            ],
            tl: /* [] */ 0
          },
          /* [] */ 0,
          Stdlib__ListLabels.rev
        ];
      }
      const partial_arg$3 = read_of_spec(spec$2);
      const read$4 = function (param, param$1, param$2) {
        return read_field(partial_arg$3, (function (vs, v) {
          return {
            hd: v,
            tl: vs
          };
        }), param, param$1, param$2);
      };
      return [
        {
          hd: [
            index$1,
            read$4
          ],
          tl: /* [] */ 0
        },
        /* [] */ 0,
        Stdlib__ListLabels.rev
      ];
    case /* Map */ 4 :
      const match$1 = param._1;
      const key_spec = match$1[0];
      const read_key = value({
        TAG: /* Basic */ 0,
        _0: [
          1,
          "key",
          "key"
        ],
        _1: key_spec,
        _2: Ocaml_protoc_plugin__Spec.default_of_spec(key_spec)
      });
      const read_value = value(match$1[1]);
      const read_entry = read_map_entry(read_key, read_value);
      const read_entry_message = function (reader) {
        const match = Ocaml_protoc_plugin__Reader.read_length_delimited(reader);
        return Curry._1(read_entry, Ocaml_protoc_plugin__Reader.create(match.offset, match.length, match.data));
      };
      const partial_arg$4 = [
        /* Length_delimited */ 3,
        read_entry_message
      ];
      const read$5 = function (param, param$1, param$2) {
        return read_field(partial_arg$4, (function (vs, v) {
          return {
            hd: v,
            tl: vs
          };
        }), param, param$1, param$2);
      };
      return [
        {
          hd: [
            param._0[0],
            read$5
          ],
          tl: /* [] */ 0
        },
        /* [] */ 0,
        Stdlib__ListLabels.rev
      ];
    case /* Oneof */ 5 :
      const make_reader = function (param) {
        const constr = param._2[0];
        const partial_arg = read_of_spec(param._1);
        const read = function (param, param$1, param$2) {
          return read_field(partial_arg, (function (param) {
            return constr;
          }), param, param$1, param$2);
        };
        return [
          param._0[0],
          read
        ];
      };
      return [
        Stdlib__ListLabels.map(make_reader, param._0[0]),
        "not_set",
        id
      ];
  }
}

const IntMap = Stdlib__Map.Make({
  compare: Stdlib__Int.compare
});

function extension_ranges(_extension_ranges) {
  while (true) {
    const extension_ranges$1 = _extension_ranges;
    if (/* tag */ typeof extension_ranges$1 === "number" || typeof extension_ranges$1 === "string") {
      return /* [] */ 0;
    }
    if (extension_ranges$1.TAG === /* Nil_ext */ 0) {
      return extension_ranges$1._0;
    }
    _extension_ranges = extension_ranges$1._1;
    continue;
  };
}

function in_extension_ranges(extension_ranges, index) {
  return Stdlib__ListLabels.exists((function (param) {
    if (Caml_obj.caml_greaterequal(index, param[0])) {
      return Caml_obj.caml_lessequal(index, param[1]);
    } else {
      return false;
    }
  }), extension_ranges);
}

function make_values(_extension_ranges) {
  if (/* tag */ typeof _extension_ranges === "number" || typeof _extension_ranges === "string") {
    return /* VNil */ 0;
  }
  if (_extension_ranges.TAG === /* Nil_ext */ 0) {
    return /* VNil_ext */ 1;
  }
  const value$1 = value(_extension_ranges._0);
  const values = make_values(_extension_ranges._1);
  return {
    TAG: /* VCons */ 0,
    _0: value$1,
    _1: values
  };
}

function deserialize_full(extension_ranges, values, constructor, reader) {
  const make_sentinel_list = function (param) {
    if (/* tag */ typeof param === "number" || typeof param === "string") {
      if (param === /* VNil */ 0) {
        return /* NNil */ 0;
      } else {
        return /* NNil_ext */ 1;
      }
    }
    const match = param._0;
    const getter = match[2];
    const v = {
      contents: match[1]
    };
    const get = function (param) {
      return Curry._1(getter, v.contents);
    };
    const fields = Stdlib__ListLabels.map((function (param) {
      const read = param[1];
      const read$1 = function (reader, field_type) {
        v.contents = Curry._3(read, v.contents, reader, field_type);
      };
      return [
        param[0],
        read$1
      ];
    }), match[0]);
    return {
      TAG: /* NCons */ 0,
      _0: [
        fields,
        get
      ],
      _1: make_sentinel_list(param._1)
    };
  };
  const create_map = function (_map, _param) {
    while (true) {
      const param = _param;
      const map = _map;
      if (/* tag */ typeof param === "number" || typeof param === "string") {
        return map;
      }
      const map$1 = Stdlib__ListLabels.fold_left((function (map, param) {
        return Curry._3(IntMap.add, param[0], param[1], map);
      }), map, param._0[0]);
      _param = param._1;
      _map = map$1;
      continue;
    };
  };
  const read = function (map, _extensions) {
    while (true) {
      const extensions = _extensions;
      if (!Ocaml_protoc_plugin__Reader.has_more(reader)) {
        return Stdlib__ListLabels.rev(extensions);
      }
      const match = Ocaml_protoc_plugin__Reader.read_field_header(reader);
      const field_number = match[1];
      const field_type = match[0];
      const read_f = Curry._2(IntMap.find_opt, field_number, map);
      if (read_f !== undefined) {
        Curry._2(read_f, reader, field_type);
        continue;
      }
      if (in_extension_ranges(extension_ranges, field_number)) {
        const field = Ocaml_protoc_plugin__Reader.read_field_content(field_type)(reader);
        _extensions = {
          hd: [
            field_number,
            field
          ],
          tl: extensions
        };
        continue;
      }
      Ocaml_protoc_plugin__Reader.read_field_content(field_type)(reader);
      continue;
    };
  };
  const sentinels = make_sentinel_list(values);
  const map = create_map(IntMap.empty, sentinels);
  const extensions = read(map, /* [] */ 0);
  let _constr = constructor;
  let _param = sentinels;
  while (true) {
    const param = _param;
    const constr = _constr;
    if (/* tag */ typeof param === "number" || typeof param === "string") {
      if (param === /* NNil */ 0) {
        return constr;
      } else {
        return Curry._1(constr, extensions);
      }
    }
    _param = param._1;
    _constr = Curry._1(constr, Curry._1(param._0[1], undefined));
    continue;
  };
}

function deserialize_fast(extension_ranges, values, constr, reader) {
  const read_fields = function (extension_ranges, _tpe, _idx, reader, _extensions, _v, _lst) {
    while (true) {
      const lst = _lst;
      const v = _v;
      const extensions = _extensions;
      const idx = _idx;
      const tpe = _tpe;
      if (lst) {
        const match = lst.hd;
        if (idx === match[0]) {
          const v$1 = Curry._3(match[1], v, reader, tpe);
          const match$1 = Ocaml_protoc_plugin__Reader.next_field_header(reader);
          if (match$1 === undefined) {
            return [
              undefined,
              extensions,
              v$1
            ];
          }
          _v = v$1;
          _idx = match$1[1];
          _tpe = match$1[0];
          continue;
        }
        
      }
      if (in_extension_ranges(extension_ranges, idx)) {
        const extensions_0 = [
          idx,
          Ocaml_protoc_plugin__Reader.read_field_content(tpe)(reader)
        ];
        const extensions$1 = {
          hd: extensions_0,
          tl: extensions
        };
        const match$2 = Ocaml_protoc_plugin__Reader.next_field_header(reader);
        if (match$2 === undefined) {
          return [
            undefined,
            extensions$1,
            v
          ];
        }
        _extensions = extensions$1;
        _idx = match$2[1];
        _tpe = match$2[0];
        continue;
      }
      if (!lst) {
        return [
          [
            tpe,
            idx
          ],
          extensions,
          v
        ];
      }
      _lst = lst.tl;
      continue;
    };
  };
  const next_field = Ocaml_protoc_plugin__Reader.next_field_header(reader);
  let _next_field = next_field;
  let _constr = constr;
  let _extensions = /* [] */ 0;
  let _vs = values;
  while (true) {
    const vs = _vs;
    const extensions = _extensions;
    const constr$1 = _constr;
    const next_field$1 = _next_field;
    if (next_field$1 === undefined) {
      let _constr$1 = constr$1;
      let _param = vs;
      while (true) {
        const param = _param;
        const constr$2 = _constr$1;
        if (/* tag */ typeof param === "number" || typeof param === "string") {
          if (param === /* VNil */ 0) {
            return constr$2;
          } else {
            return Curry._1(constr$2, Stdlib__ListLabels.rev(extensions));
          }
        }
        const match = param._0;
        _param = param._1;
        _constr$1 = Curry._1(constr$2, Curry._1(match[2], match[1]));
        continue;
      };
    }
    if (/* tag */ typeof vs === "number" || typeof vs === "string") {
      if (vs === /* VNil */ 0) {
        throw new Caml_js_exceptions.MelangeError(Restart_full, {
              MEL_EXN_ID: Restart_full
            });
      }
      throw new Caml_js_exceptions.MelangeError(Restart_full, {
            MEL_EXN_ID: Restart_full
          });
    } else {
      const match$1 = vs._0;
      const match$2 = read_fields(extension_ranges, next_field$1[0], next_field$1[1], reader, extensions, match$1[1], match$1[0]);
      _vs = vs._1;
      _extensions = match$2[1];
      _constr = Curry._1(constr$1, Curry._1(match$1[2], match$2[2]));
      _next_field = match$2[0];
      continue;
    }
  };
}

function deserialize(spec, constr) {
  const extension_ranges$1 = extension_ranges(spec);
  const values = make_values(spec);
  return function (reader) {
    const offset = Ocaml_protoc_plugin__Reader.offset(reader);
    try {
      return deserialize_fast(extension_ranges$1, values, constr, reader);
    }
    catch (raw_exn){
      const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
      if (exn.MEL_EXN_ID !== Restart_full) {
        if (exn.MEL_EXN_ID === Ocaml_protoc_plugin__Result.$$Error) {
          const match = exn._1;
          if (typeof match === "string") {
            throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
          }
          if (match.NAME !== "Required_field_missing") {
            throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
          }
          
        } else {
          throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
        }
      }
      Ocaml_protoc_plugin__Reader.reset(reader, offset);
      return deserialize_full(extension_ranges$1, values, constr, reader);
    }
  };
}

function deserialize_full$1(spec, constr) {
  const extension_ranges$1 = extension_ranges(spec);
  const values = make_values(spec);
  return function (reader) {
    return deserialize_full(extension_ranges$1, values, constr, reader);
  };
}

function deserialize_fast$1(spec, constr) {
  const extension_ranges$1 = extension_ranges(spec);
  const values = make_values(spec);
  return function (reader) {
    return deserialize_fast(extension_ranges$1, values, constr, reader);
  };
}

export {
  deserialize,
  deserialize_full$1 as deserialize_full,
  deserialize_fast$1 as deserialize_fast,
}
/* int_of_uint32 Not a pure module */
